import { createSlice } from "@reduxjs/toolkit";
import { routerChangeAction } from "const";

const initialState = {
  pageStack: 1,
};

const slice = createSlice({
  initialState,
  name: "routerPageStack",
  extraReducers: (builder) => {
    builder.addCase(routerChangeAction, (state, { payload }) => {
      //* count page stack
      const changeAction = payload.action;
      const isFirstRendering = payload.isFirstRendering;
      if (!isFirstRendering) {
        if (changeAction === "PUSH") {
          // REPLACE, POP, PUSH
          state.pageStack++;
        } else if (changeAction === "POP") {
          state.pageStack--;
        }
      }
    });
  },
});

export default slice;
